import { cycleCountIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const addCycleCountLines = unaryRpc({
  name: "addCycleCountLines" as const,
  input: z.object({
    id: cycleCountIdFormat.schema,
    /** One of these must be non-empty; which one follows the count's type. */
    productIds: z.array(productIdFormat.schema).max(500).default([]),
    storageLocationIds: z
      .array(storageLocationIdFormat.schema)
      .max(500)
      .default([]),
  }),
  output: z.object({ addedCount: z.int() }),
});
